export const
    email_titles = [
        { title: 'Email Type', dataIndex: 'name', _id: 'name' },
        { title: 'Email Address', dataIndex: 'email', _id: 'email' },
    ];
const phone_titles = [
    { title: 'Phone Type', dataIndex: 'name', _id: 'name' },
    { title: 'Phone Number', dataIndex: 'phone', _id: 'phone' },
];
const address_titles = [
    { title: 'Country', dataIndex: 'country', _id: 'country' },
    { title: 'City', dataIndex: 'city', _id: 'city' },
    { title: 'Street', dataIndex: 'street', _id: 'street' },
    { title: 'Zip Code', dataIndex: 'zip_code', _id: 'zip_code' },
    { title: 'State', dataIndex: 'state', _id: 'state' },
];
export const groupTitles = ['All Groups', 'Existing Groups'];



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/components/statics.js